import { ZoomInIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrel } from 'features/kestrelViewer'
import { useZoomToAnnotation } from 'features/kestrelViewer/hooks/useZoomToAnnotation'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation } from 'types'

const StyledZoomIcon = styled(ZoomInIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const ZoomToAnnotationButton: FC<{
  annotation: KVAnnotation
}> = ({ annotation }) => {
  const { setSelectedMarkup } = useKestrel()
  const { zoomToAnnotation } = useZoomToAnnotation()

  const handleZoom = (e: React.MouseEvent) => {
    e.stopPropagation()
    setSelectedMarkup(undefined)
    zoomToAnnotation(annotation)
  }

  return (
    <TooltipWrapper label='View annotation' side='top'>
      <div style={{ cursor: 'pointer' }} onClick={handleZoom}>
        <StyledZoomIcon width={22} height={22} />
      </div>
    </TooltipWrapper>
  )
}
